import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { getAdminPartnerDailyTransactions } from '../../services'
import { PartnerQueryKeys } from '@/modules/manage-player/keys'
import {
	AdminPartnerDailyTransactionsRequest,
	AdminPartnerDailyTransactionsResponse,
} from '@/modules/manage-player/type'

export default function useQueryGetAdminPartnerDailyTransactions(
	partnerId: string,
	payload?: AdminPartnerDailyTransactionsRequest,
	props?: UseBaseQueryOptions<AdminPartnerDailyTransactionsResponse>,
) {
	return useQuery({
		queryKey: [
			PartnerQueryKeys.GetAdminPartnerDailyTransactions,
			partnerId,
			payload,
		],
		queryFn: () => getAdminPartnerDailyTransactions(partnerId, payload),
		enabled: !!partnerId,
		...props,
	})
}
